import React from "react";
import { RestorationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import WildflowersIcon from "@ecologi/assets/icons/ProjectInsights/wildflowers.svg";
import SeagrassIcon from "@ecologi/assets/icons/ProjectInsights/seagrass.svg";
import PeatlandsIcon from "@ecologi/assets/icons/ProjectInsights/peatlands.svg";

const PATH = "/images/app/forest/habitat_restoration/pictograms/";

export const habitatRestorationVisuals: Record<
  RestorationProjectType,
  ProjectVisualsType
> = {
  [RestorationProjectType.Wildflowers]: {
    icon: <WildflowersIcon />,
    pictogram: `${PATH}wildflowers.svg`,
  },
  [RestorationProjectType.Seagrass]: {
    icon: <SeagrassIcon />,
    pictogram: `${PATH}seagrass.svg`,
  },
  [RestorationProjectType.Peatlands]: {
    icon: <PeatlandsIcon />,
    pictogram: `${PATH}peatlands.svg`,
  },
  [RestorationProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [RestorationProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
